(function() {
  function replaceJustPayLabel() {
    var btn = document.querySelector('.payment-buttons just-pay-button');
    if (!btn || !btn.shadowRoot) return false;
    var label = btn.shadowRoot.querySelector('[part="just-button-label-logo"]');
    var justBtn = btn.shadowRoot.querySelector('[part="just-button"]');
    if (label && justBtn) {
      var lang = document.documentElement.lang || '';
      label.textContent = lang.startsWith('fr') ? 'ACHAT RAPIDE' : 'QUICK BUY';
      label.style.paddingTop = '4px';

      var style = document.createElement('style');
      style.textContent = '@keyframes shine{to{left:-200%}}[part="just-button"]::after{content:"";position:absolute;top:0;left:150%;width:200%;height:100%;transform:skewX(-20deg);background-image:linear-gradient(90deg,transparent,rgba(0,0,0,0.08),transparent)}[part="just-button"]:hover::after{animation:shine .75s cubic-bezier(.01,.56,1,1)}';
      btn.shadowRoot.appendChild(style);
      return true;
    }
    return false;
  }
  if (!replaceJustPayLabel()) {
    var observer = new MutationObserver(function() {
      if (replaceJustPayLabel()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 5000);
  }
})();
